import PhysicsObject, { PhysicsObjectOptions } from "./PhysicsObject";
import { Subject } from 'rxjs';

import { Application, DisplayObject } from 'pixi.js'

export type LivingObjectOptions = {
	health?: number
	maxHealth?: number
} & PhysicsObjectOptions


export default class LivingObject extends PhysicsObject<DisplayObject, Application> {

	health
	maxHealth
	isDead = false

	onDeath$ = new Subject<void>()

	constructor({ health = 100, maxHealth = 100, ...rest }: LivingObjectOptions) {
		super(rest)

		this.health = health
		this.maxHealth = maxHealth
	}

	kill() {
		this.isDead = true
		this.onDeath$.next()
	}

	damage(amt: number) {
		this.health = Math.max(0, this.health - amt)

		if (this.health === 0) this.kill()
	}

	addGraphics(pixiApp: Application) {
		super.addGraphics(pixiApp)

		if (this.graphics) {
			const g = this.graphics
			pixiApp.renderer.plugins.viewport.addChild(g)
			this.removeCallback = () => pixiApp.renderer.plugins.viewport.removeChild(g)
		}
	}
}